<script setup>

import EditToggleButton from "../Pub/components/EditToggleButton.vue";
import {usePortalContentAndDesignStore} from "../../../stores/partners/portalContentAndDesignStore";
import {computed, ref, useSlots} from "vue";

const portalContentAndDesignStore = usePortalContentAndDesignStore();

const props = defineProps({
    to: {
        type: [String, Object],
        required: true
    },
    linkClasses: {
        type: [String, Array],
        default: ''
    },
    containerClasses: {
        type: [String, Array],
        default: ''
    },
    label: {
        type: String,
        required: true
    },
    editInputContainerClasses: {
        type: [String, Array],
        default: ''
    }
});

const isEditing = ref(false);
const hoverActive = ref(false);
const slots = useSlots();
const emit = defineEmits(["update:label"]);


const linkLabel = computed({
    get: () => props.label,
    set: (val) => emit("update:label", val)
});

const toggleEdit = () => {
    isEditing.value = !isEditing.value;
    if (!isEditing.value) {
        hoverActive.value = false;
    }
};

</script>

<template>
    <div
        :class="['relative', containerClasses]"
        @mouseenter="hoverActive = true"
        @mouseleave="hoverActive = false"
    >
        <!-- Edit toggle button shown only when live designer is active -->
        <edit-toggle-button
            v-if="portalContentAndDesignStore.liveDesignerEnabled && (isEditing || hoverActive)"
            :is-editing="isEditing"
            @toggle="toggleEdit"
            class="transition-opacity duration-200"
        />

        <!-- Display mode -->
        <router-link
            v-if="linkLabel && !isEditing"
            :to="to"
            :class="linkClasses"
        >
            <template v-if="slots['custom-content']">
                <slot name="custom-content" />
            </template>
            <template v-else>
                {{ linkLabel ?? '' }}
            </template>
        </router-link>

        <div v-else-if="isEditing" :class="editInputContainerClasses">
            <input
                type="text"
                v-model="linkLabel"
                class="block w-full text-sm rounded border-gray-300 focus:border-gray-400 focus:ring-0"
            />
        </div>
    </div>

</template>

